import React from 'react';
import { LINKS, IMAGES } from '../data/mock';

export default function Hero() {
  return (
    <section id="l1" className="chapter hero-chapter" style={{ flexDirection: 'column', justifyContent: 'center' }}>
      <div className="hero-bg" style={{ backgroundImage: `url(${IMAGES.heroBg})` }} />
      <div className="hero-bg-overlay" />

      <div style={{ zIndex: 3, width: '100%' }}>
        <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 28px', justifyContent: 'center' }}>
          <span style={{ height: 1, width: 60, background: 'linear-gradient(to left, #f3c04a, transparent)' }} />
          LIFE I &middot; SURFACE
        </div>

        <h1 className="hero-title">
          FISH<span className="gold-half">ECOIN</span>
        </h1>
        <div className="hero-sub font-sans">FISH IS SWIMMING HIGHER EVERYTIME</div>
        <div className="hero-italic">
          born of <em>Doge</em>, sistered by <em>Cate</em>, <br/>
          the goldfish that <em>never stops pumping</em>.
        </div>
        <div className="hero-meta font-sans">$FISHE &nbsp;&middot;&nbsp; SOLANA &nbsp;&middot;&nbsp; FAIR LAUNCH</div>

        <div className="hero-cta">
          <a className="pill primary" href={LINKS.pumpfun} target="_blank" rel="noreferrer">GET $FISHE</a>
          <a className="pill" href="#l2">BEGIN THE STORY &darr;</a>
        </div>
        <div className="hero-note font-sans">ON PUMP.FUN &nbsp;&middot;&nbsp; ALSO ON FOMO &amp; MOONSHOT</div>
      </div>

      <div className="scroll-hint font-sans">
        SCROLL
        <span className="line" />
      </div>
    </section>
  );
}
